module.exports = __webpack_public_path__ + "media/images/pic/courses/beginner-level-869361ce0e32ff2bfaea3ee08fc71af6.png";